// Ben Hill Griffin Stadium Detailed Accessibility Data
export const BEN_HILL_GRIFFIN_DATA = {
  venue: {
    name: "Ben Hill Griffin Stadium",
    nickname: "The Swamp",
    address: "157 Gale Lemerand Dr, Gainesville, FL 32611",
    phone: "352-375-4683",
    capacity: 88548,
    coordinates: { lat: 29.6499, lng: -82.3486 }
  },

  // Quiet Zones & Sensory Rooms
  sensoryRooms: [
    {
      id: 'sensory-north',
      name: "North End Zone Sensory Suite",
      type: "quiet_zone",
      lat: 29.6510,
      lng: -82.3486,
      floor: 1,
      section: "North End Zone - Gate 2",
      capacity: 20,
      current_occupancy: 8,
      energy_level: "low",
      amenities: [
        "noise_canceling_walls",
        "adjustable_lighting",
        "weighted_blankets",
        "fidget_tools",
        "sensory_toys",
        "bean_bag_chairs",
        "white_noise_machine",
        "live_game_feed_tv"
      ],
      access_instructions: "Enter Gate 2, proceed to North Concourse Level 1, look for green 'Sensory Room' sign",
      staffed: true,
      description: "Climate-controlled quiet space with live game feed and sensory regulation tools"
    },
    {
      id: 'sensory-south',
      name: "South End Zone Quiet Retreat",
      type: "quiet_zone",
      lat: 29.6488,
      lng: -82.3486,
      floor: 1,
      section: "South End Zone - Gate 14",
      capacity: 15,
      current_occupancy: 5,
      energy_level: "low",
      amenities: [
        "soundproof_room",
        "dim_lighting",
        "comfortable_seating",
        "noise_reducing_headphones",
        "calm_down_kits",
        "visual_schedules",
        "refrigerator_for_meds"
      ],
      access_instructions: "Enter Gate 14, turn right at concourse, room near Section 35",
      staffed: true,
      description: "Peaceful retreat with sensory-friendly environment and medical storage"
    },
    {
      id: 'sensory-west',
      name: "West Side Family Sensory Room",
      type: "quiet_zone",
      lat: 29.6499,
      lng: -82.3495,
      floor: 2,
      section: "West Concourse - Near Section 22",
      capacity: 12,
      current_occupancy: 4,
      energy_level: "low",
      amenities: [
        "private_pods",
        "nursing_area",
        "adult_changing_table",
        "rocking_chairs",
        "aromatherapy",
        "compression_vests"
      ],
      access_instructions: "West elevator to Level 2, follow blue accessibility signs",
      staffed: false,
      description: "Family-friendly sensory space with private areas and nursing facilities"
    }
  ],

  // Accessible Seating Sections
  accessibleSeating: [
    {
      id: 'ada-1-5',
      name: "Sections 1-5 - Lower Bowl Accessible",
      type: "accessible_section",
      lat: 29.6502,
      lng: -82.3480,
      energy_level: "medium",
      total_spaces: 40,
      available_spaces: 15,
      amenities: [
        "wheelchair_spaces",
        "companion_seating",
        "wide_aisles",
        "near_restroom",
        "easy_exit_access",
        "covered_overhang"
      ],
      proximity_to_exits: "Gate 1 - 50 feet",
      proximity_to_restrooms: "60 feet",
      description: "Lower bowl wheelchair accessible with shade coverage"
    },
    {
      id: 'ada-15-20',
      name: "Sections 15-20 - North Accessible",
      type: "accessible_section",
      lat: 29.6508,
      lng: -82.3486,
      energy_level: "high",
      total_spaces: 35,
      available_spaces: 12,
      amenities: [
        "wheelchair_accessible",
        "transfer_seating",
        "service_animal_area",
        "close_to_sensory_room"
      ],
      proximity_to_exits: "Gate 2 - 40 feet",
      proximity_to_restrooms: "45 feet",
      proximity_to_quiet_zones: "North Sensory Suite - 2 min walk",
      description: "North end zone accessible seating near sensory facilities"
    },
    {
      id: 'ada-35-40',
      name: "Sections 35-40 - South Accessible",
      type: "accessible_section",
      lat: 29.6490,
      lng: -82.3486,
      energy_level: "medium",
      total_spaces: 30,
      available_spaces: 18,
      amenities: [
        "wheelchair_spaces",
        "companion_seating",
        "lower_noise_area",
        "shaded_seating"
      ],
      proximity_to_exits: "Gate 14 - 35 feet",
      proximity_to_restrooms: "55 feet",
      description: "South end zone accessible with lower crowd density"
    },
    {
      id: 'sensory-seating',
      name: "Section 50-52 - Sensory-Friendly Zone",
      type: "sensory_friendly",
      lat: 29.6495,
      lng: -82.3492,
      energy_level: "low",
      total_spaces: 50,
      available_spaces: 22,
      amenities: [
        "reduced_crowd_density",
        "lower_ambient_noise",
        "flexible_seating",
        "fidget_friendly",
        "visual_schedules",
        "lower_lighting",
        "quick_exit_to_quiet",
        "autism_trained_staff"
      ],
      proximity_to_exits: "Gate 10 - 30 feet",
      proximity_to_quiet_zones: "West Sensory Room - 3 min walk",
      description: "Designated sensory-friendly seating with trained support staff"
    }
  ],

  // Emergency Exits
  emergencyExits: [
    {
      id: 'exit-gate1',
      name: "Gate 1 - Northwest",
      type: "emergency_exit",
      lat: 29.6505,
      lng: -82.3478,
      energy_level: "low",
      accessible: true,
      amenities: ["wheelchair_accessible", "ramp_access", "wide_doors", "well_lit"],
      leads_to: "Northwest parking and accessible drop-off",
      description: "Primary accessible exit with ramp to parking"
    },
    {
      id: 'exit-gate2',
      name: "Gate 2 - North",
      type: "emergency_exit",
      lat: 29.6512,
      lng: -82.3486,
      energy_level: "low",
      accessible: true,
      amenities: ["wheelchair_accessible", "automatic_doors", "direct_outdoor"],
      leads_to: "North plaza and Gator Walk area",
      description: "North main exit near sensory facilities"
    },
    {
      id: 'exit-gate10',
      name: "Gate 10 - West",
      type: "emergency_exit",
      lat: 29.6499,
      lng: -82.3498,
      energy_level: "low",
      accessible: true,
      amenities: ["wheelchair_accessible", "level_threshold", "covered_walkway"],
      leads_to: "West parking lots",
      description: "West side accessible exit"
    },
    {
      id: 'exit-gate14',
      name: "Gate 14 - South",
      type: "emergency_exit",
      lat: 29.6486,
      lng: -82.3486,
      energy_level: "low",
      accessible: true,
      amenities: ["wheelchair_accessible", "ramp_access", "shuttle_pickup"],
      leads_to: "South entrance and campus",
      description: "South main accessible exit with shuttle access"
    }
  ],

  // Guest Services
  guestServices: [
    {
      id: 'guest-main',
      name: "Main Guest Services - Gate 1",
      type: "guest_services",
      lat: 29.6504,
      lng: -82.3479,
      floor: 1,
      location: "Gate 1 Entrance",
      energy_level: "medium",
      services: [
        "Wheelchair rentals",
        "Assistive listening devices",
        "Sensory bags (headphones, fidgets, sunglasses)",
        "Visual schedule cards",
        "Large print programs",
        "Lost & found",
        "ADA coordinator on duty"
      ],
      amenities: [
        "wheelchair_rentals",
        "assistive_listening",
        "sensory_bags",
        "visual_schedules",
        "ada_coordinator"
      ],
      description: "Primary guest services with comprehensive accessibility support"
    },
    {
      id: 'medical-north',
      name: "North First Aid Station",
      type: "medical",
      lat: 29.6509,
      lng: -82.3484,
      floor: 1,
      location: "North Concourse",
      energy_level: "low",
      services: [
        "Licensed medical staff",
        "Private treatment rooms",
        "Medication storage",
        "Quiet recovery area",
        "Sensory crisis support"
      ],
      amenities: ["medical_staff", "private_rooms", "medication_storage", "quiet_recovery"],
      description: "Medical station with sensory crisis trained staff"
    },
    {
      id: 'medical-south',
      name: "South First Aid Station",
      type: "medical",
      lat: 29.6489,
      lng: -82.3488,
      floor: 1,
      location: "South Concourse",
      energy_level: "low",
      services: [
        "Emergency medical care",
        "AED available",
        "Wheelchair assistance",
        "Cooling station"
      ],
      amenities: ["emergency_care", "aed", "wheelchair_assist", "cooling_station"],
      description: "South side medical support"
    },
    {
      id: 'family-center',
      name: "Family Assistance Center",
      type: "family_services",
      lat: 29.6497,
      lng: -82.3490,
      floor: 1,
      location: "West Concourse",
      energy_level: "low",
      services: [
        "Lost child reunification",
        "Stroller check",
        "PECS communication boards",
        "Caregiver respite",
        "Neurodiversity support staff"
      ],
      amenities: ["lost_child_services", "stroller_check", "communication_boards", "respite_area"],
      description: "Family and caregiver support hub"
    }
  ],

  // Accessible Restrooms
  accessibleRestrooms: [
    {
      id: 'restroom-north',
      name: "North Concourse Accessible Restroom",
      type: "restroom",
      lat: 29.6508,
      lng: -82.3485,
      floor: 1,
      gender: "all_gender",
      energy_level: "low",
      amenities: [
        "adult_changing_table",
        "grab_bars",
        "lower_fixtures",
        "automatic_doors",
        "emergency_call",
        "quiet_location"
      ],
      description: "Family restroom with adult changing facilities"
    },
    {
      id: 'restroom-south',
      name: "South Concourse Accessible Restroom",
      type: "restroom",
      lat: 29.6490,
      lng: -82.3487,
      floor: 1,
      gender: "all_gender",
      energy_level: "low",
      amenities: [
        "adult_changing_table",
        "grab_bars",
        "wide_stalls",
        "lower_sinks"
      ],
      description: "Accessible restroom near sensory seating"
    },
    {
      id: 'restroom-west',
      name: "West Side Accessible Restroom",
      type: "restroom",
      lat: 29.6498,
      lng: -82.3494,
      floor: 1,
      gender: "all_gender",
      energy_level: "low",
      amenities: [
        "adult_changing_table",
        "grab_bars",
        "family_size",
        "baby_changing"
      ],
      description: "Family-sized accessible restroom"
    }
  ],

  // Sensory Zones (noise levels by area)
  sensoryZones: [
    {
      area: "Student Section (Sections 1-14)",
      energy_level: "high",
      triggers: ["Extreme noise 100+ dB", "Standing/jumping", "Air horns", "Dense crowds", "Gator chomp chants"],
      recommendations: "Avoid if sensitive to extreme noise - consider Sections 50-52 sensory zone"
    },
    {
      area: "North End Zone (Sections 15-25)",
      energy_level: "high",
      triggers: ["Team entrance area", "Band proximity", "Fireworks launch zone", "Crowd surges"],
      recommendations: "High energy but close to North Sensory Suite for quick retreat"
    },
    {
      area: "West Side (Sections 40-55)",
      energy_level: "medium",
      triggers: ["Moderate crowd noise", "PA system", "Some shade available"],
      recommendations: "Good balance - near sensory-friendly seating and West Family Room"
    },
    {
      area: "South End Zone (Sections 30-40)",
      energy_level: "medium",
      triggers: ["Visitor section nearby", "Lower crowd density", "More space"],
      recommendations: "Quieter option with quick access to South Quiet Retreat"
    }
  ],

  // Unseen Disabilities Support
  unseenDisabilitiesSupport: [
    { icon: "∞", label: "Neurodiversity Support", color: "#1e40af" },
    { icon: "🌊", label: "PTSD/Anxiety Zone", color: "#0ea5e9" },
    { icon: "🪑", label: "Chronic Illness Rest", color: "#22c55e" },
    { icon: "🌻", label: "Sunflower Lanyard", color: "#eab308" }
  ],

  // Communication Support
  communicationSupport: [
    { 
      name: "ASL Interpreter Services", 
      contact: "ada@ufl.edu or 352-392-1261", 
      note: "Request 72 hours in advance",
      description: "Free ASL interpretation available for deaf/hard of hearing guests"
    },
    { 
      name: "PECS Communication Boards", 
      locations: "Guest Services, Family Center, All Sensory Rooms",
      description: "Picture Exchange Communication System boards for non-verbal communication"
    },
    { 
      name: "Visual Event Schedules", 
      locations: "All sensory rooms, Guest services, Gate entrances",
      description: "Visual timeline of game day activities to reduce anxiety"
    },
    {
      name: "Assistive Listening Devices",
      locations: "Main Guest Services - Gate 1",
      description: "FM receivers and headsets for enhanced audio"
    },
    {
      name: "Large Print Programs",
      locations: "All Guest Services locations",
      description: "Game programs available in large print format"
    }
  ],

  // Pre-Visit Resources
  preparationResources: {
    website: "https://www.inclusivegameday.com",
    virtualTour: "Available at inclusivegameday.com",
    socialNarrative: "Downloadable social story for game day preparation",
    advanceVisit: "Schedule quiet venue walkthrough - contact ada@ufl.edu"
  },

  // Key Contacts
  contacts: [
    {
      id: 'ticket-office',
      name: "Gator Ticket Office",
      phone: "352-375-4683",
      type: "ticket_office",
      description: "Accessible seating requests and ticket assistance"
    },
    {
      id: 'ada-office',
      name: "UF ADA Office",
      phone: "352-273-3721",
      type: "ada_office",
      description: "Disability Resource Center for accommodation assistance"
    },
    {
      id: 'security',
      name: "Stadium Security",
      phone: "352-392-1111",
      type: "emergency",
      description: "For immediate safety concerns"
    }
  ]
};

// Helper to get all locations for the map
export function getAllStadiumLocations() {
  const data = BEN_HILL_GRIFFIN_DATA;
  const locations = [];
  
  // Add sensory rooms
  data.sensoryRooms.forEach(room => {
    locations.push({
      id: room.id,
      name: room.name,
      type: room.type,
      lat: room.lat,
      lng: room.lng,
      description: room.description,
      energy_level: room.energy_level,
      capacity: room.capacity,
      current_occupancy: room.current_occupancy,
      amenities: room.amenities,
      access_instructions: room.access_instructions
    });
  });
  
  // Add accessible seating
  data.accessibleSeating.forEach(seat => {
    locations.push({
      id: seat.id,
      name: seat.name,
      type: seat.type,
      lat: seat.lat,
      lng: seat.lng,
      description: seat.description,
      energy_level: seat.energy_level,
      capacity: seat.total_spaces,
      current_occupancy: seat.total_spaces - seat.available_spaces,
      amenities: seat.amenities
    });
  });
  
  // Add emergency exits
  data.emergencyExits.forEach(exit => {
    locations.push({
      id: exit.id,
      name: exit.name,
      type: exit.type,
      lat: exit.lat,
      lng: exit.lng,
      description: exit.description,
      energy_level: exit.energy_level,
      amenities: exit.amenities,
      leads_to: exit.leads_to
    });
  });
  
  // Add guest services
  data.guestServices.forEach(service => {
    locations.push({
      id: service.id,
      name: service.name,
      type: service.type,
      lat: service.lat,
      lng: service.lng,
      description: service.description,
      energy_level: service.energy_level,
      amenities: service.amenities,
      services: service.services
    });
  });
  
  // Add restrooms
  data.accessibleRestrooms.forEach(restroom => {
    locations.push({
      id: restroom.id,
      name: restroom.name,
      type: restroom.type,
      lat: restroom.lat,
      lng: restroom.lng,
      description: restroom.description,
      energy_level: restroom.energy_level,
      amenities: restroom.amenities
    });
  });
  
  return locations;
}
